var tweetComponent = function ($) {

    function addTweetIcons() {
        var $tweetLinksWithIcon = $('.tweet-link-with-icon');
        var iconHtml = '<svg class="tweet-link__icon" viewBox="0 0 100 100"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#twitter"></use></svg>';
        $tweetLinksWithIcon.each(function () {
            $(this).append($(iconHtml));
        });
    }

    function init() {
        addTweetIcons();
    }

    return {
        init: init
    };
}(jQuery);

$(function () {
    tweetComponent.init();
});